import gql from "graphql-tag";

export default gql`
  mutation StopProcess {
    stopProcess
  }
`;
